import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { announcementConfig } from '../../config/announcement';

// 本地存储检查逻辑
export const checkShouldShowAnnouncement = () => {
  if (!announcementConfig.enabled) {
    return false;
  }

  // 检查是否设置了永久隐藏截止日期
  if (announcementConfig.permanentHideAfter) {
    const hideDate = new Date(announcementConfig.permanentHideAfter);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (today > hideDate) {
      return false;
    }
  }

  // 检查 localStorage 中的关闭状态
  const dismissed = localStorage.getItem('announcement_dismissed');
  if (!dismissed) {
    return true;
  }

  const dismissedData = JSON.parse(dismissed);
  const dismissDuration = announcementConfig.dismissDuration;

  if (dismissDuration === 'session') {
    return false;
  }

  if (dismissDuration === 'permanent') {
    return false;
  }

  if (dismissDuration === 'day') {
    const dismissedDate = new Date(dismissedData.timestamp);
    const today = new Date();
    if (dismissedDate.toDateString() === today.toDateString()) {
      return false;
    }
    return true;
  }

  // 如果是时间戳（毫秒）
  if (typeof dismissDuration === 'number') {
    const elapsed = Date.now() - dismissedData.timestamp;
    if (elapsed < dismissDuration) {
      return false;
    }
  }

  return true;
};

const AnnouncementBanner = ({ onVisibilityChange }) => {
  const theme = useTheme();
  const [isClosing, setIsClosing] = useState(false);
  const [shouldShow, setShouldShow] = useState(() => checkShouldShowAnnouncement());

  useEffect(() => {
    // 通知父组件可见性状态
    if (onVisibilityChange) {
      onVisibilityChange(shouldShow && !isClosing);
    }
  }, [shouldShow, isClosing, onVisibilityChange]);

  const handleDismiss = (e) => {
    e.stopPropagation();
    setIsClosing(true);

    // 延迟关闭动画
    setTimeout(() => {
      setIsClosing(false);
      setShouldShow(false);

      // 保存关闭状态
      const dismissData = {
        timestamp: Date.now(),
        duration: announcementConfig.dismissDuration
      };
      localStorage.setItem('announcement_dismissed', JSON.stringify(dismissData));

      // 通知父组件可见性状态
      if (onVisibilityChange) {
        onVisibilityChange(false);
      }
    }, 300);
  };

  if (!shouldShow || isClosing) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        background: 'linear-gradient(135deg, #4353ff 0%, #6b78ff 100%)',
        color: 'white',
        py: 1,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        cursor: 'default',
        minHeight: '44px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: 'white',
            textAlign: 'center'
          }}
        >
          {announcementConfig.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'rgba(255, 255, 255, 0.9)',
            textAlign: 'center'
          }}
        >
          {announcementConfig.message}
        </Typography>
      </Box>

      <IconButton
        size="small"
        onClick={handleDismiss}
        sx={{
          position: 'absolute',
          right: 8,
          color: 'rgba(255, 255, 255, 0.8)',
          '&:hover': {
            color: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default AnnouncementBanner;
